/**
 * Per-message colour presets for the announcement marquee. The admin console
 * stores a key (marquee_messages.color); the ticker maps it back to these
 * Tailwind classes, so a message can be tinted without exposing raw classes.
 */
export interface MarqueeColorOption {
  /** Stored value (marquee_messages.color). */
  key: string;
  /** Label shown in the admin picker. */
  label: string;
  /** Text colour for the message copy. */
  text: string;
  /** Colours for the optional call-to-action chip. */
  chip: string;
  /** Swatch colour shown in the admin picker. */
  dot: string;
}

export const MARQUEE_COLORS: MarqueeColorOption[] = [
  { key: "default", label: "Default", text: "text-foreground-800", chip: "bg-primary-100 text-primary-700", dot: "bg-foreground-400" },
  { key: "brand", label: "Brand gold", text: "text-primary-700", chip: "bg-primary-500 text-foreground-950", dot: "bg-primary-500" },
  { key: "green", label: "Leaf green", text: "text-accent-700", chip: "bg-accent-100 text-accent-900", dot: "bg-accent-500" },
  { key: "terracotta", label: "Terracotta", text: "text-secondary-700", chip: "bg-secondary-100 text-secondary-900", dot: "bg-secondary-500" },
  { key: "red", label: "Alert red", text: "text-red-700", chip: "bg-red-100 text-red-700", dot: "bg-red-500" },
  { key: "dark", label: "Ink", text: "text-foreground-950", chip: "bg-foreground-900 text-background-50", dot: "bg-foreground-900" },
];

/** Resolves a stored colour key to its class bundle (falls back to default). */
export function marqueeColor(key: string | undefined): MarqueeColorOption {
  return MARQUEE_COLORS.find((c) => c.key === key) ?? MARQUEE_COLORS[0];
}